import UploadImg from '../model/uploadImg'
import AvatarImg from '../model/avatar'



const  components = {
  UploadImg,
  AvatarImg
}

const install = function (Vue,){

  Object.keys(components).forEach(key=>{
    Vue.component(key,components[key])
  })

}

const API = {
  version:'1.0.9',
  install,
  ...components
}

export default API



// WEBPACK FOOTER //
// ./src/utils/view.js